import { Search, LogOut, User as UserIcon, Upload } from 'lucide-react';
import Button from './Button';
import './DashboardHeader.css';

interface DashboardHeaderProps {
  user?: {
    firstName?: string;
    lastName?: string;
  } | null;
  onLogout: () => void;
  variant?: 'default' | 'premium';
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ user, onLogout, variant = 'default' }) => {
  return (
    <header className={`dashboard-header ${variant === 'premium' ? 'header--premium' : ''}`}>
      <div className="dashboard-header-content">
        <div className="header-left">
          <div className="search-container">
            <Search size={18} className="search-icon" />
            <input
              type="text"
              placeholder="Search transactions, cards, companies..."
              className="search-input"
            />
          </div>
        </div>

        <div className="header-right">
          {variant === 'premium' ? (
            <>
              <button className="header-action-link">
                <UserIcon size={18} />
                <span>Account</span>
              </button>

              <button className="header-action-link" onClick={onLogout}>
                <LogOut size={18} />
                <span>Logout</span>
              </button>

              <Button variant="primary" size="sm" className="header-import-btn">
                <Upload size={16} />
                Import
              </Button>
            </>
          ) : (
            <>
              <div className="user-menu">
                <span className="user-greeting">
                  Welcome back, {user?.firstName || 'admin'}
                </span>
                <Button variant="outline" size="sm" onClick={onLogout}>
                  Sign Out
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
